{
  "vitalsEntry": {
    "title": "활력 징후",
    "subtitle": "활력 징후를 기록하고 확인합니다",
    "printLabel": "활력 징후 인쇄",
    "recordSection": "활력 징후 기록",
    "save": "활력 징후 기록",
    "cancel": "취소",
    "saving": "기록 중...",
    "recordedSuccess": "활력 징후가 기록되었습니다",
    "recordedError": "활력 징후 기록에 실패했습니다",
    "invalidEncounter": "내원 ID가 유효하지 않습니다.",
    "historyTitle": "최근 활력 징후",
    "loadingHistory": "활력 징후를 불러오는 중...",
    "loadError": "활력 징후를 불러오지 못했습니다.",
    "emptyHistory": "이번 내원에 기록된 활력 징후가 없습니다.",
    "morseTitle": "Morse 낙상 위험 평가 척도",
    "bradenTitle": "Braden 욕창 위험 평가 척도",
    "riskScalesSaved": "위험도 점수가 기록되었습니다",
    "riskScalesFailed": "활력 징후는 저장되었으나 위험도 점수 기록에 실패했습니다"
  },
  "vitals": {
    "systolic": "수축기 혈압",
    "diastolic": "이완기 혈압",
    "heartRate": "심박수",
    "respiratoryRate": "호흡수",
    "temperature": "체온",
    "oxygenSaturation": "산소포화도 (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "통증 점수",
    "weight": "체중",
    "height": "신장",
    "bmi": "BMI",
    "rangeError": "{{field}}은(는) {{min}} 에서 {{max}} 사이여야 합니다",
    "placeholders": {
      "temperature": "예: 37.0",
      "heartRate": "예: 72",
      "respiratoryRate": "예: 16",
      "oxygenSaturation": "예: 98",
      "systolic": "예: 120",
      "diastolic": "예: 80",
      "weight": "예: 70.5",
      "height": "예: 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "정상",
    "borderline": "경계",
    "abnormal": "비정상",
    "critical": "위급"
  },
  "tableHeaders": {
    "dateTime": "일시",
    "temperature": "체온",
    "heartRate": "심박",
    "respiratoryRate": "호흡",
    "bloodPressure": "혈압",
    "oxygenSaturation": "SpO2",
    "weight": "체중",
    "height": "신장",
    "pain": "통증"
  },
  "io": {
    "title": "섭취량/배설량",
    "addRecord": "기록 추가",
    "addRecordSection": "섭취/배설 기록 추가",
    "loading": "섭취/배설 기록을 불러오는 중...",
    "loadError": "섭취/배설 기록 불러오기에 실패했습니다.",
    "empty": "이번 내원에 기록된 섭취/배설량이 없습니다.",
    "totals": {
      "intake": "총 섭취량",
      "output": "총 배설량",
      "balance": "순 균형",
      "totalsRow": "합계",
      "netLabel": "순"
    },
    "negativeWarning": "음의 균형 — 체액 상태를 확인하세요",
    "columns": {
      "dateTime": "일시",
      "type": "유형",
      "category": "분류",
      "amount": "양 (ml)",
      "notes": "비고"
    },
    "fields": {
      "type": "유형",
      "category": "분류",
      "amount": "양 (ml)",
      "notes": "비고"
    },
    "type": {
      "intake": "섭취",
      "output": "배설"
    },
    "categoryPlaceholder": "분류 선택...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "선택 비고...",
    "save": "기록 저장",
    "cancel": "취소",
    "missingValueShort": "--",
    "toast": {
      "added": "섭취/배설 기록이 추가되었습니다",
      "addFailed": "섭취/배설 기록 추가 실패",
      "missingFields": "필수 항목을 입력하세요"
    }
  },
  "intake": {
    "oral": "경구",
    "iv": "IV",
    "bloodProducts": "혈액제제",
    "tpn": "TPN",
    "tubeFeeding": "경관 영양",
    "other": "기타"
  },
  "output": {
    "urine": "소변",
    "drain": "배액",
    "emesis": "구토물",
    "stool": "대변",
    "bloodLoss": "출혈",
    "ngSuction": "NG 흡인",
    "other": "기타"
  },
  "wound": {
    "title": "상처 관리 기록",
    "subtitle": "내원 #{{id}} — 구조화된 상처 평가",
    "newAssessment": "새 상처 평가",
    "dimensionsTitle": "크기 (cm)",
    "woundBedTitle": "상처 기저 (%)",
    "woundBedTotalWarning": "합계: {{total}}% (100%여야 합니다)",
    "woundBedTotalOk": "합계: 100%",
    "previousTitle": "이전 평가",
    "empty": "이번 내원에 기록된 상처 평가가 없습니다.",
    "invalidEncounter": "내원 ID가 유효하지 않습니다.",
    "save": "평가 저장",
    "savedSuccess": "상처 평가가 기록되었습니다",
    "savedError": "상처 평가 저장에 실패했습니다",
    "fields": {
      "woundType": "상처 유형",
      "location": "부위",
      "stage": "단계",
      "length": "길이",
      "width": "너비",
      "depth": "깊이",
      "granulation": "육아 조직",
      "slough": "괴사 조직",
      "eschar": "가피",
      "epithelial": "상피",
      "drainageType": "삼출액 유형",
      "drainageAmount": "삼출액 양",
      "surroundingSkin": "주변 피부",
      "treatment": "적용된 처치",
      "painScore": "통증 점수 (0-10)",
      "notes": "비고"
    },
    "placeholders": {
      "length": "예: 3.5",
      "width": "예: 2.0",
      "depth": "예: 0.5",
      "treatment": "적용된 상처 관리 처치 설명...",
      "notes": "추가 관찰 사항..."
    },
    "history": {
      "dimensionsLabel": "크기",
      "drainageLabel": "삼출액",
      "painLabel": "통증",
      "treatmentLabel": "처치"
    },
    "stage": {
      "stage1": "1단계",
      "stage2": "2단계",
      "stage3": "3단계",
      "stage4": "4단계",
      "unstageable": "단계 판정 불가",
      "deepTissue": "심부 조직 손상",
      "na": "N/A"
    },
    "drainageType": {
      "none": "없음",
      "serous": "장액성",
      "sanguineous": "혈성",
      "serosanguineous": "장액혈성",
      "purulent": "화농성"
    },
    "drainageAmount": {
      "none": "없음",
      "scant": "극소량",
      "small": "소량",
      "moderate": "중등량",
      "large": "다량",
      "copious": "과다"
    },
    "woundType": {
      "pressure": "욕창(압박 손상)",
      "surgical": "수술 창상",
      "diabetic": "당뇨성 궤양",
      "venous": "정맥성 궤양",
      "arterial": "동맥성 궤양",
      "traumatic": "외상성",
      "skinTear": "피부 찢김",
      "other": "기타"
    },
    "location": {
      "sacrum": "천골",
      "coccyx": "미골",
      "leftHeel": "왼쪽 발꿈치",
      "rightHeel": "오른쪽 발꿈치",
      "leftTrochanter": "왼쪽 대전자",
      "rightTrochanter": "오른쪽 대전자",
      "abdomen": "복부",
      "leftLeg": "왼쪽 다리",
      "rightLeg": "오른쪽 다리",
      "back": "등",
      "other": "기타"
    },
    "surroundingSkin": {
      "intact": "정상",
      "erythema": "홍반",
      "macerated": "침연",
      "indurated": "경결",
      "edematous": "부종",
      "warm": "열감",
      "discolored": "변색"
    }
  },
  "carePlan": {
    "title": "간호 계획",
    "addPlan": "간호 계획 추가",
    "newPlan": "새 간호 계획",
    "createPlan": "계획 생성",
    "cancel": "취소",
    "empty": "이 환자에 대한 간호 계획이 기록되어 있지 않습니다.",
    "emptyGoals": "설정된 목표가 없습니다.",
    "goals": "목표",
    "addGoal": "목표 추가",
    "saving": "저장 중...",
    "loading": "간호 계획을 불러오는 중...",
    "loadError": "간호 계획을 불러오지 못했습니다.",
    "fields": {
      "title": "제목",
      "startDate": "시작일",
      "targetDate": "목표일",
      "description": "설명",
      "target": "목표값"
    },
    "placeholders": {
      "title": "예: 낙상 예방 계획",
      "description": "목표 설명",
      "target": "예: 30일 이내 낙상 없음"
    },
    "history": {
      "startLabel": "시작",
      "targetLabel": "목표",
      "goalsLabel": "목표 수"
    },
    "status": {
      "active": "진행 중",
      "completed": "완료",
      "cancelled": "취소됨"
    },
    "goalStatus": {
      "inProgress": "진행 중",
      "achieved": "달성",
      "notAchieved": "미달성"
    },
    "toast": {
      "planCreated": "간호 계획이 생성되었습니다",
      "planCreateFailed": "간호 계획 생성에 실패했습니다",
      "goalAdded": "목표가 추가되었습니다",
      "goalAddFailed": "목표 추가에 실패했습니다",
      "planValidation": "제목과 시작일은 필수 항목입니다",
      "goalValidation": "설명과 목표값은 필수 항목입니다"
    }
  }
}
